export class UploadJapanCountryDataConstants {
    public static DEFAULT_COUNTRY_NAME = 'JAPAN';
    public static DEFAULT_COUNTRY_CODE = 'JPN';
    public static VALUE = 'value';
    public static DATA_INSERT_SUCCESS = 'Data Inserted Successfully';
    public static DATA_INSERT_FAILED = 'Failed to Insert Data';
    public static TOTAL_CC_UPDATE_SUCCESS = 'Total CC updated successfully';
    public static TOTAL_CC_UPDATE_FAILURE  = 'Total CC updation failed';
    public static NEW_RECORD_ADDED = 'Record Successfully inserted.';
    public static RECORD_UPDATE_SUCCESS = 'Record Successfully updated.';
    public static RECORD_ALREADY_EXISTS = 'Record already exists.';

}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/upload-japan-country-data.constants.ts